const css = `.qQQMrG__container{text-overflow:ellipsis;white-space:nowrap;max-width:288px;cursor:pointer;overflow:hidden}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"container":"qQQMrG__container"};
